import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../lib/api";

const INVALID_LINK = "Ce lien de réinitialisation est invalide, expiré ou a déjà été utilisé.";

export default function PasswordReset() {
    const { token } = useParams();
    const [password, setPassword] = useState("");
    const [confirmation, setConfirmation] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [complete, setComplete] = useState(false);

    const submit = async (event) => {
        event.preventDefault();
        setError("");
        if (password !== confirmation) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }
        setSubmitting(true);
        try {
            await api.post("/auth/password-reset", {
                token,
                password,
                password_confirmation: confirmation,
            });
            setPassword("");
            setConfirmation("");
            setComplete(true);
            window.history.replaceState({}, "", "/reinitialisation-mot-de-passe/terminee");
        } catch (_) {
            setError(INVALID_LINK);
        } finally {
            setSubmitting(false);
        }
    };

    return <main className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
        <section className="w-full max-w-md rounded-2xl bg-white border border-slate-200 shadow-sm p-7">
            <h1 className="text-2xl font-bold text-slate-900">Réinitialiser le mot de passe</h1>
            {complete ? <div className="mt-6">
                <p className="text-emerald-700 font-semibold">Votre mot de passe a été réinitialisé.</p>
                <Link className="mt-5 inline-block text-orange-600 font-medium" to="/login">Retour à la connexion</Link>
            </div> : <form className="mt-6 space-y-4" onSubmit={submit}>
                <label className="block text-sm font-medium">Nouveau mot de passe<input className="mt-1 w-full rounded-lg border p-3" type="password" minLength="8" maxLength="128" autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></label>
                <label className="block text-sm font-medium">Confirmer le mot de passe<input className="mt-1 w-full rounded-lg border p-3" type="password" minLength="8" maxLength="128" autoComplete="new-password" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} required /></label>
                {error && <p className="text-sm text-red-600" role="alert">{error}</p>}
                <button className="w-full rounded-lg bg-orange-600 text-white font-semibold p-3 disabled:opacity-50" disabled={submitting}>{submitting ? "Réinitialisation…" : "Réinitialiser"}</button>
            </form>}
        </section>
    </main>;
}
